import React from "react";
import Header from "../../../Global/Header/Header";
import Footer from "../../../Global/Footer/Footer";
import { useNavigate } from "react-router-dom";
import { useAdmin } from "./../../../contextApi/adminContext";

const AdminPanel = () => {
  const navigate = useNavigate();

  const panelItems = [
    {
      name: "All Trips",
      url: "/admin/trips",
    },
    {
      name: "Create Trip",
      url: "/admin/createtrip",
    },
    {
      name: "Leads",
      url: "/admin/leads",
    },
    {
      name: "Users",
      url: "/admin/users",
    },
    {
      name: "Add Blog",
      url: "/admin/blog",
    },
    {
      name: "Reviews",
      url: "/admin/reviews",
    },
    {
      name: "Create Review",
      url: "/admin/createReview",
    },
    {
      name: "Add SVG",
      url: "/admin/svg",
    },
  ];

  const PanelWeb = () => {
    return (
        <>
        <div className="hidden w-[80%] h-auto lg:flex flex-row flex-wrap ml-[10%] mt-[10vw] mb-[15vw] gap-x-8 justify-between gap-y-[4vw]">
            {
                panelItems.map((item, index) => {
                    return (
                        <div key={index} className="w-[20%] h-[4vw] rounded-lg bg-white flex justify-center items-center cursor-pointer hover:scale-[1.1] transition-[300] border border-input" onClick={() => {navigate(`${item.url}`)}}>
                            <p className="inline">{item.name}</p>
                            </div>
                    )
                })
            }
        </div>
        </>
    )
  };

  const PanelMobile = () => {
    return (
      <>
        <div className="lg:hidden w-[80%] h-auto flex flex-col justify-center gap-y-8 ml-[10%] mt-[5vh] mb-[5vh]">
          {panelItems.map((item, index) => {
            return (
              <div
                key={index}
                className="w-full h-[8vh] bg-white rounded-md flex justify-center items-center border border-input"
                onClick={() => {
                  navigate(`${item.url}`);
                }}
              >
                <p className="inline">{item.name}</p>
              </div>
            );
          })}
        </div>
      </>
    );
  };

  return (
    <>
      <div className="w-screen min-h-screen bg-red-50">
        <Header />
        <div className="w-full h-auto">
          {<PanelWeb />}
          {<PanelMobile />}
        </div>
        <Footer />
      </div>
    </>
  );
};

export default AdminPanel;
